<template>

</template>

<script>
    export default {
        name: "NotFoundPage"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NotFoundPage.vue